import { createAction as actionCreatorFactory } from 'redux-actions';
import { actions as onboardingActions } from '#/redux/modules/onboarding/actions';

export const APP_STATUS = {
  SPLASHSCREEN: 'splash',
  NAVIGATION_BG_PLAYER_ON: 'navigation_player_on',
  NAVIGATION_BG_PLAYER_OFF: 'navigation_player_off',
  // does live need a separated status?
  PLAYER_TITLE_ON_CONTROLS_ON: 'player_title_on_controls_on',
  PLAYER_TITLE_ON_CONTROLS_OFF: 'player_title_on_controls_off',
  PLAYER_TITLE_OFF_CONTROLS_OFF: 'player_title_off_controls_off',
};

export const APP_START = 'app/APP_START';
export const APP_QUIT = 'app/APP_QUIT';
export const SET_CURRENT_VIEW = 'app/CURR_VIEW';
export const SET_NEXT_VIEW = 'app/NEXT_VIEW';
export const DEEPLINK_START = 'app/DEEPLINK_START';
export const DEEPLINK_QUIT = 'app/DEEPLINK_QUIT';
export const USER_AUTOLOADED = 'app/USER_AUTOLOADED';
export const DEEPLINK_OUTSIDE_PLAYER = 'app/DEEPLINK_OUTSIDE_PLAYER';
export const END_DEEPLINK_ON_BACK_NAV = 'app/END_DEEPLINK_ON_BACK_NAV';

export const appStart = actionCreatorFactory(APP_START);
export const appQuit = actionCreatorFactory(APP_QUIT);
export const setCurrentView = actionCreatorFactory(SET_CURRENT_VIEW);
export const setNextView = actionCreatorFactory(SET_NEXT_VIEW);
export const deepLinkStart = actionCreatorFactory(DEEPLINK_START);
export const deepLinkQuit = actionCreatorFactory(DEEPLINK_QUIT);
export const userAutoloaded = actionCreatorFactory(USER_AUTOLOADED);
export const deeplinkOutsidePlayer = actionCreatorFactory(
  DEEPLINK_OUTSIDE_PLAYER,
);
export const allowEndDeeplinkOnBackNav = actionCreatorFactory(
  END_DEEPLINK_ON_BACK_NAV,
);
export const exitDeeplinkWorkflow = () => async dispatch => {
  dispatch(deepLinkQuit());
  dispatch(deeplinkOutsidePlayer(false));
  dispatch(onboardingActions.setProfileDeepLink(false));
  dispatch(allowEndDeeplinkOnBackNav(false));
};
